import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("boco_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const LOGO =
  "https://customer-assets-lqy194kg.emergentagent.net/job_botetourt-clean/artifacts/znf1fxmi_779167536_122099624787447798_4458297362945533395_n.jpg";
export const FLYER =
  "https://customer-assets-lqy194kg.emergentagent.net/job_botetourt-clean/artifacts/29krn9ho_780487789_122099624985447798_5871288912000701011_n.jpg";

export const HERO_IMG =
  "https://images.pexels.com/photos/3935320/pexels-photo-3935320.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1000";
export const MOUNTAINS_IMG =
  "https://images.unsplash.com/photo-1694293151507-54836f948a5e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const BRAND = {
  name: "BOCO BINS LLC",
  tagline: "CLEAN. SANITIZE. DEODORIZE.",
  phone: "540-384-0797",
  phoneHref: "tel:5403840797",
  email: "bocobins@gmail.com",
  location: "Buchanan, VA 24066",
};

export const COMMUNITIES = [
  "Buchanan",
  "Botetourt County",
  "Salem",
  "Roanoke County",
  "Lexington",
  "Buena Vista",
  "Troutville",
  "Daleville",
  "Eagle Rock",
];

export const EXTRA_CAN_PRICE = 10;

export const PLANS = [
  { key: "one_can", name: "1 Can", price: 25, cadence: "per cleaning",
    desc: "Perfect for a single trash or recycling can. Cleaned, sanitized and deodorized." },
  { key: "biweekly", name: "Bi-Weekly", price: 60, cadence: "every 2 weeks",
    desc: "2 cans cleaned every two weeks on a rotating schedule. Our best value for busy households.", featured: true },
  { key: "monthly_service", name: "Monthly Service", price: 35, cadence: "per month",
    desc: "Covers up to 2 cans, kept fresh all year. Add more cans for just $10/mo each." },
  { key: "two_cans", name: "2 Cans", price: 40, cadence: "per cleaning",
    desc: "Ideal for households with two cans. Both fully cleaned inside and out." },
];

const ASSETS = "https://customer-assets-lqy194kg.emergentagent.net/job_botetourt-clean/artifacts";
export const GALLERY = [
  { title: "Inside the Bin", before: `${ASSETS}/mf7kcky1_784222719_122101091277447798_7238661612327592791_n.webp`, after: `${ASSETS}/k942o4zt_784430441_122101091433447798_5743239097114190325_n.webp` },
  { title: "Lid & Body", before: `${ASSETS}/lo80u1v4_783981439_122101091349447798_3450763664070748534_n.webp`, after: `${ASSETS}/xqfi6ty7_784080422_122101091481447798_430185005788195278_n.webp` },
];

export const REVIEWS = [
  { name: "Suzanne Harris", location: "Verified Customer", rating: 5, text: "My outdoor trash can hadn't been cleaned in years, and it was getting pretty ripe. It looks and smells better than new! Thanks, guys!" },
];

